(function ($, window) {

	let prodigy_product = {
		_weight_type_mapper: ['lbs', 'g', 'kg', 'oz'],
		_dimension_type_mapper: ['in', 'cm'],
		_stock_status_mapper: { 'in_stock': 'In stock', 'out_of_stock': 'Out of stock' },
		_add_to_cart_key: 'add_item_to_cart',
		product: {},
		is_subscription_replaced: false,
		remote_product: {},
		variant: {},
		maxItems: 9999,
		is_admin: false,
		is_tiered_price: false,
		selectedVariant: [],
		active_bulk_attribute_name: '',
		min_quantity: 1,
		add_to_cart_button_element: '.add-to-cart-js',
		enable_bulk_element: '.enable-bulk-js',
		disable_bulk_button_element: '.disable-bulk-button-js',
		product_counter_input_element: '.counter-count-js',
		prodigy_product_swatch_element: '.prodigy-product__swatch-js',
		is_variant_was_chosen: false,
		product_stock_element: '.prodigy-product-stock-js',
		product_default_info_price_element: '.product-default-info-price-js',
		prodigy_product_swatch_block_element: '.prodigy-product__swatch-block-js',
		is_variant_gallery: false,
		selected_attributes: [],
		bulk_variants_info: [],
		_masterVariantInitialized: false,
		_initialDisplayedPrice: '',

		init: function () {
			let is_product_page = $('body').hasClass('single-prodigy-product');
			let is_shop_page = $('body').hasClass('tax-prodigy-product-shop');
			this.is_admin = settings.is_admin;
			this.is_tiered_price = Boolean($('.is_tired_price-js').val());
			this._initialDisplayedPrice = this.get_initial_displayed_price();
			if (this.is_tiered_price) {
				localStorage.setItem('min_quantity', this.min_quantity);
			}

			if (!is_shop_page && is_product_page) {
				if (!this.is_variants()) {
					this.get_master_variant_data();
				}
				this.set_product_counter();
				this.reset_focus_to_press_enter();
				this.change_product_quantity_analytic_event();
				if (this.is_variants()) {
					if (this.is_swatches()) {
						this.change_swatch_value();
					} else {
						this.set_variant_dropdown();
						this.update_variants_dropdown();
						this.set_attribute_value_options();
					}
					this.set_customised_variant_selection();
				}
				this.set_variant_data();
				this.set_elementor_options();
				this.customise_sort_select();
				this.add_item_to_cart();
				this.hide_empty_div();
				prodigyProductBulk.set_bulk_variants_data();

				this.set_bulk();
				if (prodigyProductBulk.is_active_logo_bulk) {
					$(document).trigger('enable-multiple-quantity');
				}

				if (!prodigyProductBulk.is_active_bulk) {
					this.show_available_variants();
				}
				if (this.is_tiered_price) {
					this.get_tiered_prices_range_ajax(this.get_master_variant_id());
					this.close_tiered_price_popup();
				}

				if (prodigyProductBulk.is_bulk_enabled()) {
					let active_bulk_attribute = $('.bulk-container-js:visible').data('attribute');
					this.set_variant_modifier(active_bulk_attribute);
				}
				this.set_redemption_price();
			}
		},

		get_master_variant_id: function () {
			return $('#product_id').val();
		},

		set_redemption_price: function () {
			if (parseInt(settings.redemption_store)) {
				$('.prodigy-bulk__subtotal-save').hide();
			} else {
				$('.prodigy-bulk__subtotal-save').show();
			}
		},

		show_available_variants: function () {
			let selected = [];
			let allowed_variants = $('.variants-options-intersect-js').data('options');
			if (this.is_swatches()) {
				$('.prodigy-product__swatch-js:checked').each(function () {
					let attr_name = $(this).data('attribute');
					selected[attr_name] = $(this).data('slug');
				});

				$('.prodigy-product__swatch-js').each(function () {
					let attr_name = $(this).data('attribute');
					let attr_value = $(this).data('slug');

					let hide_control = true;
					for (let i in allowed_variants) {
						let is_accepted = allowed_variants[i][attr_name] === attr_value;
						for (let selected_attr_name in selected) {
							if (attr_name === selected_attr_name) {
								continue;
							}
							is_accepted = is_accepted && allowed_variants[i][selected_attr_name] === selected[selected_attr_name];
						}

						if (is_accepted) {
							hide_control = false;
							break;
						}
					}

					if (hide_control) {
						$(this).parent().hide();
					} else {
						$(this).parent().show();
					}
				});
			} else {
				$('.attribute_values_js').each(function () {
						let $option = $(this).find('option:selected');
						let attr_value = $option.data('slug');
						let attr_name = $option.data('attribute');
						selected[attr_name] = attr_value;
					},
				);

				$('.attribute_values_js option').each(function () {
					let attr_value = $(this).data('slug');
					let attr_name = $(this).data('attribute');
					let hide_control = true;
					for (let i in allowed_variants) {
						let is_accepted = allowed_variants[i][attr_name] === attr_value;
						for (let selected_attr_name in selected) {
							if (attr_name === selected_attr_name) {
								continue;
							}
							is_accepted = is_accepted && allowed_variants[i][selected_attr_name] === selected[selected_attr_name];
						}

						if (is_accepted) {
							hide_control = false;
							break;
						}
					}

					if (hide_control) {
						$(this).addClass('d-none');
					} else {
						$(this).removeClass('d-none');
					}
				});
			}
		},

		show_available_variants_bulk: function (active_attribute) {
			let selected = [];
			let allowed_variants = $('.variants-options-intersect-js').data('options');

			if (this.is_swatches()) {
				$('.prodigy-product__swatch-js:checked').each(function () {
					let attr_name = $(this).data('attribute');
					let attr_value = $(this).data('slug');
					if (attr_name !== active_attribute) {
						selected[attr_name] = attr_value;
					}
				});
			} else {
				$('.attribute_values_js').each(function () {
						let $option = $(this).find('option:selected');
						let attr_value = $option.data('slug');
						let attr_name = $option.data('attribute');
						if (attr_name !== active_attribute) {
							selected[attr_name] = attr_value;
						}
					},
				);
			}

			$('.bulk-container-js[data-attribute="' + active_attribute + '"]').find('input').each(function () {
				let hide_control = true;
				let attr_value = $(this).data('option');
				for (let i in allowed_variants) {
					let is_accepted = allowed_variants[i][active_attribute] === attr_value;
					for (let selected_attr_name in selected) {
						is_accepted = is_accepted && allowed_variants[i][selected_attr_name] === selected[selected_attr_name];
					}

					if (is_accepted) {
						hide_control = false;
						break;
					}
				}

				if (hide_control) {
					$(this).val('');
					$(this).attr('disabled', true);
					$(this).closest('.prodigy-bulk__table-cell-body').addClass('prodigy-bulk__table-cell-body--disabled');
				} else {
					$(this).attr('disabled', false);
					$(this).closest('.prodigy-bulk__table-cell-body').removeClass('prodigy-bulk__table-cell-body--disabled');
				}
			});
		},

		close_tiered_price_popup: function () {
			$(document).on('click', '.close-tiered-prices-js', function () {
				$('#minorderQTY').modal('hide');
			});
		},

		get_options: function () {
			let self = this;
			let selected_options = [];
			if (this.is_swatches()) {
				$(self.prodigy_product_swatch_element).each(
					function () {
						let swatch_block = $(this).closest(self.prodigy_product_swatch_block_element);
						if ($(this).is(':checked') && !$(swatch_block).hasClass('ignored')) {
							let value = $(this).val();
							let option_name = $(this).data('option-name');
							$(this).closest('.swatch-container-js').find('.swatch-attribute-name-js').html('&nbsp;' + option_name);
							selected_options.push(value);
						}
					},
				);
			} else {
				$('.attribute_values_js').each(function () {
						let $option = $(this).find('option:selected');
						if ($option.val() !== '') {
							selected_options.push($option.val());
						}
					},
				);
			}

			return selected_options;
		},

		set_bulk: function () {
			let self = this;
			$(document).on('enable-multiple-quantity', function (e, context) {
				let bulk_attr = $(context).data('attribute');
				if (typeof bulk_attr === 'undefined') {
					bulk_attr = $('.bulk-container-js:visible').data('attribute');
				}
				let bulk_options = self.get_bulk_options(bulk_attr);
				self.set_variant_modifier(bulk_attr, bulk_options);

				if (product_logo_management_object.is_logo() && !prodigyProductBulk.is_active_logo_bulk) {
					product_logo_management_object.set_logos();
				}
				if (
					product_logo_management_object.is_logo() &&
					product_logo_management_object.logo_attribute === bulk_attr &&
					prodigyProductBulk.is_active_logo_bulk
				) {
					product_logo_management_object.update_locations_availability(bulk_attr, bulk_options);
					product_logo_management_object.set_bulk_logo_option_validate(bulk_attr, bulk_options);
					product_logo_management_object.bulk_logo_validate(bulk_attr, bulk_options);
					product_logo_management_object.bulk_locations_validate();
					prodigyProductBulk.set_bulk_data();
				}
			});
		},

		get_bulk_options: function (bulk_attr) {
			let self = this;
			let $container = $('.bulk-container-' + bulk_attr + '-js');
			$(self.disable_bulk_button_element).attr('data-value', $container.data('slug'));
			let modifierOptions = [];
			if (product_logo_management_object.is_logo() && prodigyProductBulk.is_active_logo_bulk) {
				let $logo_bulk_container = $('.bulk-container-' + product_logo_management_object.logo_attribute + '-js');
				if (typeof bulk_attr !== 'undefined') {
					$logo_bulk_container.each(function (e) {
							$(this).find(prodigyProductBulk.input_bulk_quantity_element).each(function (e) {
								let name = jQuery.trim($(this).data('option'));
								let id = $(this).data('option-id');
								modifierOptions.push({ id: id, name: name });
							});
						},
					);
				} else {
					let $selected_color = $('.attribute_values_js[data-slug="color"] option:selected');
					if ($selected_color.length > 0) {
						let name = $selected_color.data('slug');
						let id = $selected_color.data('option-id');
						modifierOptions.push({ id: id, name: name });
					}
				}
			}

			return modifierOptions;
		},

		set_variant_modifier: function (attribute, modifierOptions = []) {
			let self = this;
			if (modifierOptions.length === 0) {
				$('.bulk-container-' + attribute + '-js').each(function (e) {
					$(this).find(prodigyProductBulk.input_bulk_quantity_element).each(function (e) {
						let name = jQuery.trim($(this).data('option'));
						let id = $(this).data('option-id');
						modifierOptions.push({ id: id, name: name });
					});
				});
			}

			if (self.is_variants()) {
				let attributes = self.get_attributes_for_query();
				if (Object.keys(attributes.attribute).length === 1 && $('.bulk-container-js').length === 1) {
					attributes.attribute = [];
				}
				if (Object.keys(self.clear_selected_attributes(attributes.attribute)).length > 1) {
					for (const [key, value] of Object.entries(attributes.attribute)) {
						let selected_value = $(self.disable_bulk_button_element).data('value');
						if (value === selected_value) {
							delete attributes.attribute[key];
						}
					}
				}
				prodigyProductBulk.get_bulk_variant_data(attributes.attribute, modifierOptions);
			}
		},

		clear_selected_attributes: function (values) {
			$.each(values, function (key, val) {
				if ('Choose an option' === val) {
					delete values[key];
				}
			});

			return values;
		},

		set_elementor_options: function () {
			let is_show_regular_price = $('#regular_price_state_option').val();

			if (is_show_regular_price !== 'yes') {
				$('.regular-price-container').remove();
			} else {
				$('.regular-price-container').show();
			}
			prodigyProductSubscription.set_subscriptions();
			if (this.is_bulk()) {
				this.open_bulk_option();
			}
		},

		open_bulk_option: function () {
			let i = 0;
			let is_show_certain_bulk_block = $('.is_show_certain_bulk_block').val();
			let number_certain_bulk_block = $('.number_certain_bulk_block').val();
			$('.bulk-container-js').each(function () {
				if (is_show_certain_bulk_block && number_certain_bulk_block == i) {
					prodigyProductBulk.open_bulk_options_mode($(this));
				}
				i++;
			});
		},

		add_item_to_cart: function () {
			let self = this;
			$(document)
				.off('click', 'button.add-to-cart-js, button.replace-subscription-condition-js')
				.on('click', 'button.add-to-cart-js, button.replace-subscription-condition-js',
					function (e) {
						if (!self.validate_options() && !self.is_bulk_opened()) {
							return;
						}

						if (!prodigyProductPersonalization.is_user_personalization_validate()) {
							return;
						} else {
							prodigyProductPersonalization.delete_personalization_errors();
						}

						let current_button = $(this).attr('data-name');

						if (current_button === 'replace-subscription-condition-js') {
							$('#add_item_Modal').modal('hide');
							prodigyProductSubscription.is_show_subscription_popup = false;
							self.is_subscription_replaced = true;
						} else {
							self.is_subscription_replaced = false;
						}

						if (prodigyProductSubscription.is_show_subscription_popup) {
							$('#add_item_Modal').modal('show');
							prodigyProductSubscription.is_show_subscription_popup = false;
						} else {
							self.set_analytic_add_item_to_cart();
							let form_count_products = $(self.product_counter_input_element).val();
							if (self.is_validate_options()) {
								if (self.is_variants() || product_logo_management_object.is_logo()) {
									if (prodigyProductBulk.is_active_bulk) {
										let variants = self.bulk_variants_info;
										if (
											prodigyProductBulk.has_bulk_color_attribute() ||
											product_logo_management_object.is_option_has_required_logo()
										) {
											variants = product_logo_management_object.get_logo_options(self.bulk_variants_info);
											if (typeof variants.logo_options_ids !== 'undefined') {
												delete variants.logo_options_ids;
											}
										}
										self.add_to_cart(
											form_count_products,
											variants,
											prodigyProductBulk.bulkVariants,
											prodigyProductPersonalization.get_personalization_data(),
											null,
											null,
											false,
											true,
										);
									} else {
										let variant = product_logo_management_object.get_logo_options(self.variant);
										self.add_to_cart(
											form_count_products,
											variant,
											self.get_attributes_for_query(),
											prodigyProductPersonalization.get_personalization_data(),
											self.get_current_product_price(),
											prodigyProductSubscription.subscription_id,
											self.is_subscription_replaced,
											false,
										);
									}
								} else {
									self.add_to_cart(
										form_count_products,
										self.variant,
										self.get_attributes_for_query(),
										prodigyProductPersonalization.get_personalization_data(),
										self.get_current_product_price(),
										prodigyProductSubscription.subscription_id,
										self.is_subscription_replaced,
										false,
									);
								}
							}
						}

					},
				);
		},

		get_quantity_of_products: function () {
			let self = this;
			let products_quantity = 0;

			if (prodigyProductBulk.is_active_logo_bulk) {
				$(this.bulk_container_element).each(function (e) {
					let is_visible = $(this).is(':visible');
					if (is_visible) {
						$(this).find(self.input_bulk_quantity_element).each(function (e) {
							let bulk_input_value = parseInt($(this).val());
							if (!isNaN(bulk_input_value)) {
								products_quantity += bulk_input_value;
							}
						});
					}
				});
			} else {
				products_quantity = $(self.product_counter_input_element).val();
			}

			return products_quantity;
		},

		get_attributes_for_query: function () {
			let attribute_values_js = $('.attribute_values_js:not(.ignored)');
			let attribute_swatch = $('.prodigy-product__swatch-block-js:not(.ignored)');
			let attributes = { attribute: {}, item: {} };
			attribute_values_js.each(
				function (key) {
					let $option = $(this).find('option:selected');
					attributes['attribute'][key] = $option.data('slug');
					attributes['item'][key] = $option.text();
				},
			);

			attribute_swatch.find('.prodigy-product__swatch-js').each(
				function (key) {
					if ($(this).is(':checked')) {
						attributes['attribute'][key] = $(this).data('slug');
						attributes['item'][key] = $(this).val();
					}
				},
			);

			return attributes;
		},

		get_current_product_price: function () {
			let price = 0;
			let price_str = $(document).find('.sale-price').text().trim();

			if (prodigyProductSubscription.is_subscriptions() && !prodigyProductSubscription.is_one_time_order) {
				price = parseFloat(prodigyProductSubscription.subscription_price);
			}

			if (prodigyProductSubscription.is_one_time_order && price_str !== '') {
				price = prodigy_price_format(price_str).replace(/\,/g, '');
			}

			return price;
		},

		is_bulk: function () {
			return $(this.enable_bulk_element).length;
		},

		is_bulk_opened: function () {
			return $('.prodigy-bulk__wrap').is(':visible');
		},

		add_to_cart: function (
			number_of_product,
			variants,
			attributes_item,
			personalization = [],
			price = null,
			subscription_id = null,
			is_subscription_replaced = false,
			is_bulk = false,
		) {
			let self = this;
			let post_data = {
				action: 'prodigy-add-product-to-cart',
				variants: variants,
				count: number_of_product,
				price: price,
				attributes: attributes_item,
				is_subscription_replaced: is_subscription_replaced,
				is_bulk: is_bulk,
				personalization: personalization,
				nonce: settings.nonce,
			};
			self.show_cart_button_loader();

			if (!prodigyProductSubscription.is_one_time_order) {
				post_data.subscription_id = subscription_id;
			}
			clearTimeout(self.timeoutAddToCartId);
			self.timeoutAddToCartId = setTimeout(
				function () {
					$.ajax(
						{
							type: 'post',
							data: post_data,
							dataType: 'json',
							url: ajax_url,
							error: function (data) {
								if (self.is_tiered_price && data.error_code && data.error_code === 422) {
									self.show_tiered_price_modal(data);
									return;
								}

								if (window.prodigy_cart_widget !== undefined) {
									window.prodigy_cart_widget.cart_modal_trigger(true);
								}
								self.show_error(data.responseJSON.data);
							},
							success: function (data) {
								if (self.is_bulk_opened()) {
									prodigyProductBulk.reset_bulk_inputs();
								}

								if (window.prodigy_cart_widget !== undefined) {
									window.prodigy_cart_widget.cart_modal_trigger(false);
								}

								self.cart_slide_open();
								self.show_add_to_cart_message();
								self.show_cart_message();
								if (self.is_tiered_price) {
									self.get_tiered_prices_range_ajax(self.get_master_variant_id());
								} else {
									$(self.product_counter_input_element).val(1);
								}

								self.hide_cart_button_loader();
								$(document).trigger('prodigy:cart:updated');
								// redirect to cart page
								if ($('.cart-redirect-js').data('cart-redirect') === 'redirect_to_cart') {
									let dinamic_cart_url = settings.prodigy_cart_url;
									window.location.replace(dinamic_cart_url);
								}
							},
						},
					);
				},
				500,
			);
		},

		show_cart_button_loader: function () {
			$(this.add_to_cart_button_element).prop('disabled', true);
			$(this.add_to_cart_button_element).attr('aria-busy', true);
		},

		hide_cart_button_loader: function () {
			$(this.add_to_cart_button_element).prop('disabled', false);
			$(this.add_to_cart_button_element).attr('aria-busy', false);
		},

		show_tiered_price_modal: function (data) {
			let cart_slider = $('.prodigy-cart-slide-js');
			cart_slider.removeClass('prodigy-cart-slide--open');
			$('body').removeClass('overflow-hidden');
			if (typeof data.message !== undefined) {
				$('.tiered-price-message-js').text(data.message);
				$('#minorderQTY').modal('show');
			}
		},

		cart_slide_open: function () {
			let cart_slider = $('.prodigy-cart-slide-js');
			let slider = cart_slider.data('auto-open');
			if (slider === 'yes' || slider) {
				cart_slider.toggleClass('prodigy-cart-slide--open');
				$('body').toggleClass('overflow-hidden');
				$('.prodigy-cart-slide__toggle').attr('aria-expanded', 'true');
				setTimeout(
					function () {
						cart_slider.removeClass('prodigy-cart-slide--open');
						$('body').removeClass('overflow-hidden');
						$('.prodigy-cart-slide__toggle').attr('aria-expanded', 'false');
					},
					10000,
				);
			}
		},

		set_checked_swatch: function () {
			let self = this;
			self.selectedVariant = [];

			$(self.prodigy_product_swatch_element).each(function () {
				let swatch_block = $(this).closest(self.prodigy_product_swatch_block_element);
				if ($(this).is(':checked') && !$(swatch_block).hasClass('ignored')) {
					let option_slug = $(this).data('slug');
					let option_id = $(this).val();
					let attribute = swatch_block.data('attribute');
					let option_name = $(this).data('option-name');
					$(this).closest('.swatch-container-js').find('.swatch-attribute-name-js').html('&nbsp;' + option_name);
					self.selectedVariant.push(option_slug);
					self.set_attribute_option_logo(attribute, option_slug, option_id);
				}
			});
		},

		set_attribute_option_logo: function (attribute, option_slug, option_id) {
			let self = this;
			let options = {};

			if (typeof option_slug === 'undefined') {
				prodigyProductGallery.set_product_gallery();
			}

			if (
				typeof option_slug !== 'undefined' &&
				typeof attribute !== 'undefined' &&
				product_logo_management_object.is_logo() &&
				product_logo_management_object.is_option_has_image(attribute, option_slug) &&
				attribute === product_logo_management_object.logo_attribute
			) {
				self.show_logo_container();
				options[0] = { name: option_slug };
				prodigyProductGallery.set_gallery(options, attribute);
				self.set_logo(option_slug);
			}

			if (attribute === product_logo_management_object.logo_attribute) {
				if (!product_logo_management_object.is_option_has_logo(option_id)) {
					options[0] = { name: option_slug };
					prodigyProductGallery.set_gallery(options, attribute);
					self.hide_logo_container();
				} else {
					self.show_logo_container();
				}
			}

			if (
				typeof option_slug !== 'undefined' &&
				typeof attribute !== 'undefined' &&
				!product_logo_management_object.is_logo() &&
				product_logo_management_object.is_option_has_image(attribute, option_slug)
			) {
				options[0] = { name: option_slug };
				prodigyProductGallery.set_gallery(options, attribute);
			}

		},

		show_logo_container: function () {
			$('.logo-container-js').show();
		},

		hide_logo_container: function () {
			$('.logo-container-js').hide();
		},

		set_logo: function (option_slug = null) {
			product_logo_management_object.update_forms_visibility(option_slug);
			if (product_logo_management_object.is_logo_swatches) {
				product_logo_management_object.set_logos_swatches(option_slug);
			} else {
				product_logo_management_object.set_logos(option_slug);
			}
		},

		change_swatch_value: function () {
			let self = this;
			$(document).on('change', self.prodigy_product_swatch_element, function () {
				self.set_checked_swatch();
				if (!prodigyProductBulk.is_bulk_enabled()) {
					self.set_variant_data();
				}

				if (prodigyProductBulk.is_active_bulk) {
					prodigyProductBulk.activate_bulk_processes();
				}

				self.show_available_variants();

				if (self.is_bulk()) {
					$(this).parent().parent().closest('.prodigy-product__attr-item--no-select').find(self.enable_bulk_element).attr('data-value', $(this).data('slug'));
				}
			});
		},

		get_active_swatches: function () {
			let active_options = [];
			$('.prodigy-product__swatch-js:checked').each(function () {
				active_options.push($(this).data('slug'));
			});

			return active_options;
		},

		get_active_swatches_attributes: function () {
			let self = this;
			let active_attributes = [];
			$('.prodigy-product__swatch-js:checked').each(function () {
				active_attributes.push($(this).closest(self.prodigy_product_swatch_block_element).data('attribute'));
			});

			return active_attributes;
		},

		set_variant_data() {
			let logo_id = false;
			this.set_checked_swatch();
			if (this.is_variants() && this.is_validate_options()) {
				let number_of_items = parseInt($(this.product_counter_input_element).val());

				if (product_logo_management_object.is_logo()) {
					logo_id = product_logo_management_object.get_logo_id();
				}

				if (!this.is_bulk_opened()) {
					this.get_variant_data(this.get_selected_variant(), number_of_items, logo_id);
				}
			}
		},

		get_selected_variant() {
			let self = this;
			let selectedVariant = [];
			if ($(self.prodigy_product_swatch_element).length > 0) {
				$(self.prodigy_product_swatch_element).each(function () {
					let swatch_block = $(this).closest(self.prodigy_product_swatch_block_element);
					if ($(this).is(':checked') && !$(swatch_block).hasClass('ignored')) {
						let slug = $(this).data('slug');
						selectedVariant.push(slug);
					}
				});
			} else {
				$('.attribute_values_js').each(function () {
					let current_slug = $(this).find('option:selected').data('slug');

					if (!$(this).hasClass('ignored') && $(this).parent().is(':visible')) {
						selectedVariant.push(current_slug);
					}
				});
			}
			return selectedVariant;
		},

		set_active_bulk_attribute_name: function () {
			let self = this;
			$(prodigyProductBulk.bulk_container_element).each(function () {
					if ($(this).is(':visible')) {
						self.active_bulk_attribute_name = $(this).data('attribute');
					}
				},
			);
		},

		set_variant_dropdown: function () {
			let is_variant_gallery_prev = this.is_variant_gallery;
			this.selectedVariant = [];
			this.is_variant_gallery = false;
			if (
				!this.is_bulk() &&
				this.is_variant_gallery === false &&
				is_variant_gallery_prev !== this.is_variant_gallery
			) {
				prodigyProductGallery.restore_default_image_gallery();
			}

			this.selectedVariant = [...new Set(this.selectedVariant)];
		},

		set_attribute_value_options: function () {
			let self = this;
			let $option = false;

			$('.attribute_values_js').each(function () {
				$option = $(this).find('option:selected');
				self.set_option_value($option.data('attribute'), $option.data('slug'));
			});
		},

		set_option_value: function (attribute, option_slug) {
			let self = this;
			let options_list = {};

			if (
				typeof option_slug !== 'undefined' &&
				typeof attribute !== 'undefined' &&
				product_logo_management_object.is_logo() &&
				product_logo_management_object.is_option_has_image(attribute, option_slug) &&
				attribute === product_logo_management_object.logo_attribute
			) {
				options_list[0] = { name: option_slug };
				prodigyProductGallery.set_gallery(options_list, attribute);
				self.set_logo(option_slug);
			}

			if (
				typeof option_slug !== 'undefined' &&
				typeof attribute !== 'undefined' &&
				!product_logo_management_object.is_logo() &&
				product_logo_management_object.is_option_has_image(attribute, option_slug)
			) {
				options_list[0] = { name: option_slug };
				prodigyProductGallery.set_gallery(options_list, attribute);
			}

			self.selected_attributes[option_slug] = option_slug;

			if (!$(this).hasClass('ignored') && option_slug !== '') {
				self.selectedVariant.push(option_slug);
				if (self.is_bulk()) {
					$(this).parent().find(self.enable_bulk_element).attr('data-slug', option_slug);
				}
			}
		},

		choose_variant_dropdown: function () {
			let self = this;
			let $attribute_values = $('.attribute_values_js');
			if (!prodigyProductBulk.is_active_bulk) {
				this.show_available_variants();
			}
			this.set_variant_dropdown();

			if (this.get_selected_variant().length === $attribute_values.length) {
				this.isVariantSelected = true;
			}
			if (this.isVariantSelected && this.is_validate_options()) {
				self.show_cart_button_loader();
				if (this.is_variants()) {
					let number_of_items = parseInt($(self.product_counter_input_element).val());
					if (this.is_bulk_opened()) {
						prodigyProductBulk.set_bulk_data();
					} else {
						if (this.is_validate_options() && !self.is_bulk_opened()) {
							let logo_id = product_logo_management_object.get_logo_id();
							if (!self.is_bulk_opened()) {
								this.get_variant_data(this.get_selected_variant(), number_of_items, logo_id);
							}
						}
					}
				}
			} else {
				prodigyProductSubscription.is_one_time_order = true;
				this.show_master_variant_info();

				if (typeof self.remote_product.remote_master_variant_info !== 'undefined') {
					let dimension_attrs = this.remote_product.remote_master_variant_info.dimension.attributes;
					this.set_shipping_data_variants(
						this.remote_product.remote_main_sku,
						dimension_attrs['weight-value'] + dimension_attrs['weight-unit'],
						dimension_attrs['depth-value']
						+ ' x ' + dimension_attrs['width-value']
						+ ' x ' + dimension_attrs['height-value']
						+ dimension_attrs['size-unit'],
					);
				}
			}
		},

		get_variant_data: function (
			variant,
			number_of_items = null,
			logo_id = false,
			selector = null,
			is_bulk = false,
			bulk_attribute = false,
		) {
			let self = this;
			let post_data = {
				action: 'prodigy-public-get-variant-data',
				post_id: $('#product_id').val(),
				variants: variant,
				options: this.get_options(),
				number_of_items: number_of_items,
				is_bulk: is_bulk,
				bulk_attribute: bulk_attribute,
				logo_id: logo_id,
				is_personalization: prodigyProductPersonalization.is_personalization(),
				location: window.location.href,
				nonce: settings.nonce,
			};

			clearTimeout(self.timeoutVariantsDataId);
			$(self.add_to_cart_button_element).prop('disabled', true);
			$(self.add_to_cart_button_element).removeAttr('data');
			self.timeoutVariantsDataId = setTimeout(
				function () {
					$.ajax(
						{
							type: 'post',
							data: post_data,
							dataType: 'json',
							url: ajax_url,
							error: function (xhr, status, error) {
								$(self.add_to_cart_button_element).prop('disabled', true);
								$(self.add_to_cart_button_element).attr('data', 'loader');
							},
							success: function (response) {
								self.is_variant_was_chosen = true;
								if (response.data.result && typeof response.data.result[0] !== 'undefined') {
									self.variant = response.data.result[0];
									$('#variant-data-js').attr('data-variant', JSON.stringify(response.data.result[0]));
									$('#variant-data-js').data('variant', response.data.result[0]);
								}
								if (typeof self.variant === 'undefined') {
									return;
								}
								$(self.add_to_cart_button_element).removeAttr('data');
								if (self.is_bulk_opened()) {
									$(self.add_to_cart_button_element).removeAttr('disabled');
									prodigyProductBulk.update_bulk_price(response.data);
									self.update_bulk_info(response.data.result);
									$('#variant-data-js').attr('data-bulk-variants', JSON.stringify(response.data));
									$('#variant-data-js').data('bulk-variants', response.data);
								}

								if (typeof self.variant !== 'undefined') {
									prodigyProductSubscription.set_subscription_block(self.variant);
								}
								self.set_variants_data(self.variant);
								self.set_product_data_for_cart(self.variant);

								if (!prodigyProductSubscription.is_subscriptions()) {
									prodigyProductSubscription.is_one_time_order = true;
								}

								self.set_shipping_data(self.variant);
								self.disable_add_to_cart_button_loader();

								if (!self.is_bulk_opened() && !self.is_variant_was_chosen && self.is_tiered_price) {
									self.set_tiered_prices(self.variant);
								}
							},
						},
					);
				},
				500,
			);
		},

		update_bulk_info: function (data) {
			this.bulk_variants_info = data;
		},

		disable_add_to_cart_button_loader: function () {
			$(this.add_to_cart_button_element).prop('disabled', false);
		},

		set_tiered_prices: function (product) {
			var range = product && product.tiered_prices_range;
			if (!range || typeof range.min_quantity === 'undefined') {
				return;
			}
			this.min_quantity = range.min_quantity;
			if (this.is_tiered_price) {
				localStorage.setItem('min_quantity', range.min_quantity);
				if (parseFloat(range.min_price) !== parseFloat(range.max_price)) {
					let range_price_string = 'From $' + prodigy_price_format(range.min_price) + ' to $' + prodigy_price_format(range.max_price);
					$('.prodigy-product__main-price-range-js').text(range_price_string);
				}

				$(this.product_counter_input_element).val(range.min_quantity);
				$(document).find('.counter-btn-minus-js').prop('disabled', true);
			}
		},

		set_shipping_data: function (product) {
			if (typeof product !== 'undefined' && typeof product.dimension !== 'undefined') {
				let dimension_attrs = product.dimension.attributes;
				this.set_shipping_data_variants(
					product.attributes.sku,
					dimension_attrs['weight-value'] + dimension_attrs['weight-unit'],
					dimension_attrs['depth-value']
					+ ' x ' + dimension_attrs['width-value']
					+ ' x ' + dimension_attrs['height-value']
					+ dimension_attrs['size-unit'],
				);
			}
		},

		update_variants_dropdown: function () {
			let self = this;
			let variantsObj = $('div.variants-container-js');
			let variants = variantsObj.data('variants');
			if (variants !== 'undefined') {
				$('select[data-attribute]').each(function () {
					self.update_select($(this), variants, {});
				});
				let dropdownOpened = false;
				MsDropdown.make('.attribute_values_js', {
					enableAutoFilter: false,
					on: {
						open: function () {
							dropdownOpened = true;
						},
						change: function (data) {
							if (dropdownOpened) {
								let option_id = $(data.option).data('option-id');
								let option_slug = $(data.option).data('slug');
								let attribute = $(data.option).closest('.attribute_values_js').data('attribute');

								self.set_attribute_option_logo(attribute, option_slug, option_id);

								if (!prodigyProductBulk.is_bulk_enabled()) {
									self.set_variant_data();
								}

								if (prodigyProductBulk.is_active_bulk) {
									prodigyProductBulk.activate_bulk_processes();
								}

								self.show_available_variants();

								if (self.is_bulk()) {
									$(this).parent().parent().closest('.prodigy-product__attr-item--no-select').find(self.enable_bulk_element).attr('data-value', $(this).data('slug'));
								}
								self.is_variant_was_chosen = true;

								dropdownOpened = false;
							}
						},
					},
				});
			}
		},

		is_variants: function () {
			let attributes = $('.variants-container-js').data('attributes');
			if (attributes !== undefined) {
				return Boolean(attributes.length);
			}
		},

		update_select: function ($select, variants, selected_attributes) {
			let self = this;
			let attributes = $('.variants-container-js').data('attributes');
			let available_attributes = {};

			for (i in variants) {
				let variant = variants[i];
				for (j in attributes) {
					let attr_name = attributes[j];
					if (typeof variant[attr_name] !== 'undefined') {
						let value = Object.values(variant[attr_name])[0];
						if (value !== undefined) {
							if (available_attributes[attr_name] === undefined) {
								available_attributes[attr_name] = [];
							}
							available_attributes[attr_name][value.name] = value;
						}
					}
				}
			}

			if ($select.length > 0) {
				let attr_name = $select.data('attribute');
				let default_select_option = $('#default_select_option').val();
				$select.html('<option class="attributes_default_value-js prodigy-attr__default-value" value="">' + default_select_option + '</option>');
				let orderedVariants = [];
				if (typeof available_attributes[attr_name] !== 'undefined') {
					Object.values(available_attributes[attr_name]).sort(this.compareBySort).forEach(
						function (variant) {
							orderedVariants.push(variant.name);
						},
					);
				}

				available_attributes = self.set_default_if_single_variant_option(available_attributes);

				orderedVariants.forEach(function (i) {
						let attr_value_name = available_attributes[attr_name][i].name;
						let attr_value_slug = available_attributes[attr_name][i].slug;
						let attr_value_id = available_attributes[attr_name][i].option_id;
						let attr_value_logos = JSON.stringify(available_attributes[attr_name][i].logos);
						let attr_value_attribute = available_attributes[attr_name][i].attribute;

						let option = $('<option>').text(attr_value_name).val(attr_value_slug);
						let dataColorProperties = '';

						// set color like a picture
						if (available_attributes[attr_name][i].color != undefined) {
							const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
							svg.setAttribute('width', '100');
							svg.setAttribute('height', '100');
							svg.style.backgroundColor = 'black';

							const rect = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
							rect.setAttribute('width', '100%');
							rect.setAttribute('height', '100%');
							rect.setAttribute('fill', available_attributes[attr_name][i].color);
							svg.appendChild(rect);

							const svgData = new XMLSerializer().serializeToString(svg);
							const svgBase64 = btoa(svgData);
							const dataUrl = 'data:image/svg+xml;base64,' + svgBase64;
							option.attr('data-image', dataUrl);
						}
						if (available_attributes[attr_name][i].image !== undefined) {
							option.attr('data-image', available_attributes[attr_name][i].image);
						}

						option.addClass('attached enabled');
						if (dataColorProperties) {
							option.attr('style', '--data-color:' + dataColorProperties);
						}
						option.attr('data-attribute', attr_value_attribute);
						option.attr('data-logos', attr_value_logos);
						option.attr('data-slug', attr_value_slug);
						option.attr('data-option-id', attr_value_id);
						if (
							selected_attributes[attr_name] === attr_value_name ||
							available_attributes[attr_name][i].default
						) {
							option.attr('selected', true);
						}
						$select.append(option);
					},
				);
			}
		},

		set_default_if_single_variant_option: function (available_attributes) {
			for (j in available_attributes) {
				if (Object.values(available_attributes[j]).length === 1) {
					let key = Object.keys(available_attributes[j]);
					available_attributes[j][key].default = true;
				}
			}

			return available_attributes;
		},

		compareBySort: function (a, b) {
			return a.sort - b.sort;
		},

		scroll_for_hash: function (hash) {
			if (hash) {
				var hash = hash;

				$('html, body').animate(
					{
						scrollTop: $(hash).offset().top,
					},
					1500,
					'swing',
				);
			}
		},

		/**
		 *
		 * @version 2.0.0
		 */
		set_analytic_add_item_to_cart: function () {
			if (settings.pg_google_track_id !== '') {
				let current_url = window.location.pathname.replace(/\/+$/, '');
				if (current_url.includes(settings.product_type)) {
					let self = this;
					let product = self.variant;
					let price = product.attributes.price;
					let sku = product.attributes.sku;
					let title = product.attributes.sku;
					let sale_price = product.attributes['sale-price'];
					let remote_variant_id = product.remote_variant_id;
					if (settings.pg_google_track_id !== '') {
						gtag(
							'event',
							'add_to_cart',
							{
								'event_category': 'prodigy_ecommerce',
								'items': [
									{
										'id': remote_variant_id,
										'name': title,
										// "category": product.categories,
										'variant': sku,
										'price': self.get_actual_price(price, sale_price),
										'quantity': parseInt($(self.product_counter_input_element).val()),
									},
								],
							},
						);
					}
				}
			}
		},

		/**
		 * @version 2.0.0
		 */
		change_product_quantity_analytic_event: function () {
			let self = this;
			if (settings.pg_google_track_id !== '') {
				let current_url = window.location.pathname.replace(/\/+$/, '');
				if (current_url.includes(settings.product_type)) {
					let old_quantity = parseInt($(self.product_counter_input_element).val());

					$('.counter-btn-plus-js, .counter-btn-minus-js').on(
						'click',
						function () {
							let product = self.variant;

							let price = product.attributes.price;
							let sku = product.attributes.sku;
							let title = product.attributes.sku;
							let sale_price = product.attributes['sale-price'];
							let remote_variant_id = product.remote_variant_id;
							if (settings.pg_google_track_id !== '') {
								gtag(
									'event',
									'change_product_quantity',
									{
										'event_category': 'prodigy_product',
										'items': [
											{
												'id': remote_variant_id,
												'name': title,
												'sku': sku,
												'price': self.get_actual_price(price, sale_price),
												'new_quantity': parseInt($(self.product_counter_input_element).val()),
												'old_quantity': old_quantity,
											},
										],
									},
								);
							}
						},
					);
				}
			}
		},

		/**
		 * @version 2.0.0
		 * @param data
		 */
		set_view_product_analytic_event: function (data) {
			let current_url = window.location.pathname.replace(/\/+$/, '');

			if (typeof data.attributes !== 'undefined') {
				let price = data.attributes.price;
				let sku = data.attributes.sku;
				let title = data.attributes.sku;
				let sale_price = data.attributes['sale-price'];
				let remote_variant_id = data.remote_variant_id;

				if (typeof current_url.includes(settings.product_type)) {
					let self = this;
					if (settings.pg_google_track_id !== '') {
						gtag(
							'event',
							'view_variant',
							{
								'event_category': 'prodigy_product',
								'items': [
									{
										'id': remote_variant_id,
										'name': title,
										// "category": data.categories,
										'variant': sku,
										'price': self.get_actual_price(price, sale_price),
									},
								],
							},
						);
					}
				}
			}
		},

		captcha_callback: function (val) {
			$('.recaptcha-checkbox').attr('aria-checked', true);
			window.prodigyProductReview.check_enable_comment_fields();
		},

		reset_focus_to_press_enter: function () {
			let self = this;
			$(document).on(
				'keypress blur focusout',
				self.product_counter_input_element,
				function (e) {
					self.update_counter_of_products(self, $(this));
				},
			);
		},

		update_counter_of_products: function (self, container) {
			self.get_inventory_data();
			let number_of_items = parseInt($(self.product_counter_input_element).val());
			if (
				this.is_tiered_price &&
				this.is_variants() &&
				this.is_validate_options()
			) {
				let logo_id = product_logo_management_object.get_logo_id();
				if (!this.is_bulk_opened()) {
					this.get_variant_data(this.get_selected_variant(), number_of_items, logo_id);
				}
			} else if (this.is_tiered_price && this.is_validate_options()) {
				this.get_master_variant_data(number_of_items);
			}

			if (parseInt(container.val()) > 1) {
				$('.counter-btn-minus-js').prop('disabled', false);
			}
		},

		show_cart_message() {
			var add_to_cart_message = $('.widget-cart-add-item-message-js');
			add_to_cart_message.show();
			add_to_cart_message.delay(5000).fadeOut('slow');
		},

		show_view_cart_btn() {
			var view_cart = $('.view-cart-js');
			view_cart.show();
			$('.prodigy-product__values').removeClass('flex-nowrap');
		},

		show_add_to_cart_message() {
			var self = this;
			$(self.add_to_cart_button_element).prop('disabled', true);
			self.show_cart_message();
			self.show_view_cart_btn();

			setTimeout(
				function () {
					$(self.add_to_cart_button_element).prop('disabled', false);
				},
				5000,
			);
		},

		show_error: function (message, type = 'success') {
			let self = this;
			let add_to_cart_message = $('.widget-cart-message-error-js');
			add_to_cart_message.find('span').html(message);
			add_to_cart_message.show();
			add_to_cart_message.delay(5000).fadeOut('slow');
			if (type === 'error') {
				add_to_cart_message.addClass('prodigy-cart-dropdown__error-alert');
			}
			self.hide_cart_button_loader();
		},

		set_shipping_data_variants: function (
			sku,
			weight,
			dimension,
		) {
			let prodigy_additional_weight_js = $('.prodigy-additional-weight-js');
			let prodigy_additional_dimensions_js = $('.prodigy-additional-dimensions-js');
			let product_sku_value = $('.product_sku_value');

			prodigy_additional_weight_js.text(weight);
			prodigy_additional_dimensions_js.text(dimension);
			product_sku_value.text(sku);
		},

		counter_reset: function () {
			$(this.product_counter_input_element).val(1);
		},

		set_product_counter: function () {
			let self = this;
			const counterCount = $(self.product_counter_input_element);
			counterCount.inputmask({ regex: '^[1-9][0-9]*|$', rightAlign: false });

			$(document).on(
				'click',
				'.counter-btn-minus-js',
				function () {
					self.get_inventory_data();
					let number_of_items = parseInt($(self.product_counter_input_element).val()) - 1;
					if (!self.is_bulk_opened()) {
						if (self.is_tiered_price && self.is_variants() && self.is_validate_options()) {
							let logo_id = product_logo_management_object.get_logo_id();
							if (!self.is_bulk_opened()) {
								self.get_variant_data(self.get_selected_variant(), number_of_items, logo_id);
							}
						} else if (self.is_tiered_price && self.is_validate_options()) {
							self.get_master_variant_data(number_of_items);
						}
					}

					$(self.add_to_cart_button_element).prop('disabled', false);

					const counterCount = $(self.product_counter_input_element);
					const minusBtn = $('.counter-btn-minus-js');
					let counter = parseInt(counterCount.val());
					if (counter !== self.min_quantity) {
						counterCount.val(--counter);
						if (counter <= self.min_quantity) {
							minusBtn.prop('disabled', true);
						}
					}
				},
			);

			$(document)
				.off('click', '.counter-btn-plus-js')
				.on(
					'click',
					'.counter-btn-plus-js',
					function () {
						self.get_inventory_data();
						let number_of_items = parseInt($(self.product_counter_input_element).val()) + 1;
						if (!self.is_bulk_opened()) {
							if (self.is_tiered_price && self.is_variants() && self.is_validate_options()) {
								let logo_id = product_logo_management_object.get_logo_id();
								if (!self.is_bulk_opened()) {
									self.get_variant_data(self.get_selected_variant(), number_of_items, logo_id);
								}
							} else if (self.is_tiered_price && self.is_validate_options()) {
								self.get_master_variant_data(number_of_items);
							}
						}

						const counterCount = $(self.product_counter_input_element);
						let counter = parseInt(counterCount.val());
						const minusBtn = $('.counter-btn-minus-js');
						counterCount.val(++counter);
						if (counter > self.min_quantity) {
							minusBtn.prop('disabled', false);
						}
					},
				);
		},

		get_inventory_data: function () {
			let self = this;

			let post_data = {
				action: 'prodigy-remote-get-inventory-product',
				post_id: $('#product_id').val(),
				nonce: settings.nonce,
			};
			clearTimeout(self.timeouInventorytId);
			self.timeouInventorytId = setTimeout(
				function () {
					$.ajax(
						{
							type: 'post',
							data: post_data,
							dataType: 'json',
							url: ajax_url,
							success: function (data) {
								if (typeof data.attributes !== 'undefined') {
									self.set_stock_status(data.attributes);
								}
							},
						},
					);
				},
				500,
			);
		},

		set_stock_status: function (inventory, is_variant) {
			let self = this;

			let current_quantity = $(this.product_counter_input_element).val();
			let inventory_quantity = parseInt(localStorage.getItem('items_quantity'));
			let is_out_of_stock = this.check_out_of_stock_status(inventory, current_quantity);
			if (inventory['manage-stock'] && !inventory['backorderable'] && inventory_quantity > 0) {
				self.maxItems = inventory_quantity;
			}
			if (is_out_of_stock) {
				this.set_out_of_stock_status();
			} else if (inventory['manage-stock']) {
				if (($('.attribute_values_js').length !== 0 && !is_variant) || inventory_quantity === 0) {
					self.set_out_of_stock_status();
				} else {
					self.disable_minus_button();
					self.set_in_stock_status(inventory);
				}
			} else if (is_variant && inventory['manage-stock'] && inventory['backorderable'] && inventory['stock'] === 'in_stock' && inventory_quantity === 0) {
				self.set_in_stock_status(inventory);
			} else if (is_variant && !inventory['manage-stock'] && inventory['stock'] === 'in_stock') {
				self.set_in_stock_status(inventory);
			} else if (is_variant && !inventory['manage-stock'] && inventory['stock'] === 'out_of_stock') {
				self.set_out_of_stock_status();
			}
		},

		is_swatches: function () {
			return $(this.prodigy_product_swatch_block_element).length !== 0;
		},

		show_product_data: function (data_object, price, sale_price, subscriptions, inventory = [], items_quantity = 1, is_selected_variant = false) {
			if (!is_selected_variant && $('.main-price-js').text() !== prodigy_price_format(price)) {
				localStorage.setItem('product-range', $('.main-price-js').text().trim());
			}

			this.show_product_price(price, sale_price, data_object.tiered_price, items_quantity, is_selected_variant);

			if (prodigyProductSubscription.is_subscriptions()) {
				prodigyProductSubscription.show_subscription_block(is_selected_variant, subscriptions, price);
				prodigyProductSubscription.format_subscription_price(price);
			}

			this.show_variant_inventory(inventory);
			this.show_variant_sku(data_object);
		},

		show_variant_inventory: function (inventory) {
			if (typeof inventory.attributes !== 'undefined') {
				localStorage.setItem('items_quantity', inventory.attributes.count);
				this.show_status(inventory.attributes, true, true);
				this.clear_default_info();
				this.is_variant_was_chosen = true;
				if (this.is_tiered_price) {
					const counterCount = $(self.product_counter_input_element);
					let counter = parseInt(counterCount.val());
					const minusBtn = $('.counter-btn-minus-js');
					counterCount.val(counter);
					if (counter > self.min_quantity) {
						minusBtn.prop('disabled', false);
					}
				} else if (inventory.attributes['manage-stock']) {
					this.counter_reset();
				}
			}
		},

		calculate_product_price: function (start_price, tiered_price = null, items_quantity = 1, include_setup_charge = true) {
			let logo_price = 0;
			let location_price = 0;
			let total_price = 0;
			let actual_price = 0;
			let total_price_with_personalization = 0;
			let personalization_price = 0;
			const $mainPrice = $('.prodigy-product-list__item-price-js.main-price-js');

			if ((tiered_price !== undefined && (parseFloat(tiered_price) > 0))) {
				actual_price = prodigy_price_format(parseFloat(tiered_price));
				total_price = actual_price * items_quantity;
			} else {
				actual_price = this.get_actual_price(start_price);
				total_price = actual_price * items_quantity;
			}

			if (product_logo_management_object.is_logo()) {
				logo_price = product_logo_management_object.get_logos_price() * items_quantity;
				location_price = product_logo_management_object.get_location_price() * items_quantity;
				total_price = total_price + logo_price + location_price;
				if (include_setup_charge) {
					total_price += parseFloat($('#product-setup-charge-js').val()) || 0;
				}
			}

			if (prodigyProductPersonalization.is_personalization()) {
				if (prodigyProductPersonalization.is_personalization_filled()) {
					personalization_price = prodigyProductPersonalization.calculate_personalization_price(actual_price) * items_quantity;
					total_price = total_price + personalization_price;
				} else {
					total_price_with_personalization = total_price + prodigyProductPersonalization.calculate_personalization_price(actual_price) * items_quantity;
					$mainPrice.data('personalization-price', parseFloat(total_price_with_personalization));
				}
			}

			$mainPrice.data('total-price', total_price);
			return total_price;
		},

		show_product_price: function (price, sale_price, tiered_price, items_quantity, is_selected_variant) {
			const $attrSelect = $('.attribute_values_js');
			const $subscriptionBlock = $('.subscriptions');
			const $mainCurrency = $('.main-price-currency-js');
			const $mainPrice = $('.prodigy-product-list__item-price-js');
			const $salePrice = $('.prodigy-product-list__item-price--sale');
			const $saleInfo = $('.sale-price-container');
			const $regularInfo = $('.regular-price-container');
			const $saleBottomValue = $('.sale-price');
			const $rangePrice = $('.prodigy-product__main-price-range-js');
			const $stockEl = $(this.product_stock_element);

			const hasAttributesOrSwatches = $attrSelect.length !== 0 || this.is_swatches();

			if (hasAttributesOrSwatches && !is_selected_variant) {
				this.handle_stock_and_price_info(this.product_stock_element, $regularInfo, $saleInfo);
				$subscriptionBlock.hide();
				$mainCurrency.hide();
				// Keep server-rendered price/range visible on first load.
				// Re-rendering here can hide the tiered price block before first variant/quantity AJAX response.
				return;
			}
			const total_price = this.calculate_product_price(price, tiered_price);
			const total_sale_price = this.calculate_product_price(sale_price, tiered_price);
			const actual_price = Number(total_price);
			const actual_formated_price = Number.isFinite(actual_price) && actual_price >= 0 ? ('$' + prodigy_price_format(actual_price)) : '';

			const actual_sale_price = Number(total_sale_price);
			const actual_formated_sale_price = Number.isFinite(actual_sale_price) && actual_sale_price >= 0 ? ('$' + prodigy_price_format(actual_sale_price)) : '';

			this.handle_stock_and_price_info(this.product_stock_element, $regularInfo, $saleInfo);

			if (!actual_formated_price) {
				return;
			}

			if (!this.is_sale_price_valid(sale_price)) {
				return;
			}

			if (price === '') {
				return;
			}

			this.set_price_text($mainPrice, $salePrice, $saleBottomValue, $rangePrice, actual_formated_sale_price, actual_formated_price);
			this.show_elements($regularInfo, $saleInfo, $stockEl);
			$regularInfo.hide();
		},

		get_initial_displayed_price: function () {
			const candidates = [
				$('.main-price-js').first().text().trim(),
				$('.prodigy-product-list__item-price-default-js.prodigy-product-list__item-price-js').first().text().trim(),
				$('.prodigy-product__main-price').first().text().trim(),
			];

			for (let i = 0; i < candidates.length; i++) {
				if (candidates[i]) {
					return candidates[i];
				}
			}

			return '';
		},

		hide_elements: function (...elements) {
			elements.forEach(function (element) {
				if (typeof $(element) !== 'undefined') {
					$(element).hide();
				}
			});
		},

		show_elements: function (...elements) {
			elements.forEach(function (element) {
				if (typeof $(element) !== 'undefined') {
					$(element).show();
				}
			});
		},

		set_price_text: function ($priceElement, $salePriceElement, $saleBottomElement, $rangePrice, sale_price, original_price = null) {
			let self = this;

			if (self.is_variant_was_chosen !== undefined) {
				let is_price_show_sale_format = $('#is_show_price_sale_format-js').val();
				$rangePrice.hide();
				$('.prodigy-product__main-variant-price-js').show();
				const showSale = Number(is_price_show_sale_format) === 1;
				const hasSale = sale_price != null && sale_price !== '';
				const price = hasSale ? sale_price : original_price;

				$priceElement.text(price);
				$saleBottomElement.text(price);
				if (sale_price !== original_price) {
					$salePriceElement.toggle(showSale && hasSale).text(original_price);
				}
				if (self.is_variant_was_chosen) {
					$('.prodigy-product-list__item-price-default-js').hide();
					if (!self.is_tiered_price && hasSale && showSale) {
						$('.prodigy-product-list__item-price--sale').show();
					}
					$('.prodigy-product-list__item-price-js').show();
				}
			}
		},

		is_sale_price_valid: function (salePrice) {
			return typeof salePrice !== 'undefined';
		},

		handle_stock_and_price_info: function (stock_info, regular_price_info, sale_price_info) {
			this.hide_elements(stock_info, regular_price_info, sale_price_info);
		},

		show_master_variant_info: function () {
			let self = this;
			if (
				typeof this.remote_product !== 'undefined' &&
				this.remote_product.remote_main_price !== null
			) {

				let subscriptions = false;
				if (typeof this.remote_product.remote_master_variant_info !== 'undefined') {
					subscriptions = typeof this.remote_product.remote_master_variant_info['subscription-plan'] !== 'undefined';
				}

				let price = 0;
				let sale_price = 0;
				if (typeof this.remote_product.remote_main_price !== 'undefined') {
					price = this.remote_product.remote_main_price.price;

					if (self.is_tiered_price) {
						price = this.remote_product.tiered_price;
						if (
							(price === undefined || price === null || price === '') &&
							this.remote_product.tiered_price_range &&
							this.remote_product.tiered_price_range.min_price !== undefined
						) {
							price = this.remote_product.tiered_price_range.min_price;
						}
					}
					sale_price = this.remote_product.remote_main_price['sale-price'];

					this.show_product_data(
						this.remote_product,
						price,
						sale_price,
						subscriptions,
						this.remote_product.remote_master_variant_info.inventory,
						this.get_quantity_of_products(),
					);
				}

				self.show_master_product_info();
			}
		},

		show_master_product_info: function () {
			let self = this;
			if (
				typeof this.remote_product !== 'undefined' &&
				typeof this.remote_product.remote_master_variant_info !== 'undefined' &&
				this.remote_product.remote_master_variant_info.inventory &&
				typeof this.remote_product.remote_master_variant_info.inventory.attributes !== 'undefined'
			) {
				localStorage.setItem('items_quantity', this.remote_product.remote_master_variant_info.inventory.attributes.count);
			}

			if (!self.is_variants()) {
				self.hide_cart_button_loader();
			}

			if (
				typeof this.remote_product.remote_master_variant_info !== 'undefined'
				&& typeof this.remote_product.remote_master_variant_info.inventory !== 'undefined'
			) {
				this.show_status(this.remote_product.remote_master_variant_info.inventory.attributes, self.is_variants(), false);
				self.clear_default_info();
			}

			if (
				this.product.meta &&
				typeof this.product.meta.product_sku !== 'undefined' &&
				this.product.meta.product_sku[0]
			) {
				var main_product_sku = this.product.meta.product_sku[0];
				$('.product_sku_value').text(main_product_sku);
			}

			if (!prodigyProductSubscription.is_subscriptions()) {
				prodigyProductSubscription.is_one_time_order = true;
			}

			prodigyProductSubscription.load_subscription_price();
		},

		apply_tiered_price_range: function (range) {
			let self = this;
			const $mainPrice = $('.prodigy-product-list__item-price-js.main-price-js');
			self.min_quantity = range.min_quantity;
			$(self.product_counter_input_element).val(range.min_quantity);
			if (self.is_tiered_price && !self.is_variant_was_chosen) {
				localStorage.setItem('min_quantity', range.min_quantity);
				$(document).find('.counter-btn-minus-js').prop('disabled', true);
			}
			if (!product_logo_management_object.is_logo()) {
				if (parseFloat(range.min_price) === parseFloat(range.max_price)) {
					$mainPrice.text('$' + prodigy_price_format(range.min_price));
				} else {
					let range_price_string = 'From $' + prodigy_price_format(range.min_price) + ' to $' + prodigy_price_format(range.max_price);
					$('.prodigy-product__main-price-range-js').text(range_price_string);
				}
			}
		},

		get_tiered_prices_range_ajax: function (product_id) {
			let self = this;

			// Use PHP-inlined tiered price range on first call to avoid an AJAX round-trip.
			// Subsequent calls (e.g. after add-to-cart) clear the inline value and fall through to AJAX.
			let $inline = $('#tiered-price-range-data-js');
			if ($inline.length && $inline.val()) {
				try {
					let range = JSON.parse($inline.val());
					if (range && range.min_quantity !== undefined) {
						$inline.val(''); // consume once so next call uses AJAX
						self.apply_tiered_price_range(range);
						return;
					}
				} catch (e) {}
			}

			let post_data = {
				action: 'prodigy-get-tiered-prices-range',
				product_id: product_id,
				nonce: settings.nonce,
			};

			clearTimeout(self.timeoutTieredtId);
			self.timeoutTieredtId = setTimeout(function () {
				$.ajax({
					type: 'post',
					data: post_data,
					dataType: 'json',
					url: ajax_url,
					success: function (data) {
						self.apply_tiered_price_range(data.data);
					},
				});
			}, 500);
		},

		show_status: function (inventory, has_variant, select_variant) {
			let self = this;
			let inventory_quantity = parseInt(localStorage.getItem('items_quantity'));
			if (typeof inventory_quantity !== 'undefined' && inventory['manage-stock']) {
				self.maxItems = inventory_quantity;
			}
			let is_variant = (has_variant && select_variant) || !has_variant;

			if (typeof inventory.stock !== 'undefined') {
				self.set_stock_status(inventory, is_variant);
			}
		},

		clear_default_info: function () {
			$(this.product_default_info_price_element).hide();
			$('.product-default-info-js').hide();
		},

		disable_minus_button: function () {
			var minus = $('.counter-btn-minus-js');

			if (parseInt($(self.product_counter_input_element).val()) === self.min_quantity) {
				minus.prop('disabled', true);
			} else {
				minus.prop('disabled', false);
			}
		},

		set_out_of_stock_status: function () {
			$(this.product_stock_element).text(this._stock_status_mapper['out_of_stock']);
		},

		set_in_stock_status: function (inventory) {
			let plus = $('.counter-btn-plus-js');
			let count_input = $(self.product_counter_input_element);
			count_input.prop('disabled', false);
			plus.prop('disabled', false);
			$(this.add_to_cart_button_element).prop('disabled', false);
			let counter = inventory.count !== null ? inventory.count : '';
			if (counter === 0 && inventory.stock === 'in_stock') {
				counter = '';
			}
			$(this.product_stock_element).show();
			$(this.product_stock_element).text(this._stock_status_mapper[inventory.stock] + ' ' + counter);
		},

		check_out_of_stock_status: function (inventory, current_quantity) {
			let result = false;
			if (inventory && inventory.stock !== 'in_stock' && typeof inventory.count !== 'undefined') {
				if (inventory.count < current_quantity) {
					result = true;
				}
			}

			return result;
		},

		get_actual_price: function (price, sale_price) {
			if (sale_price === '' || !sale_price) {
				return parseFloat(price);
			} else {
				return parseFloat(sale_price);
			}
		},

		set_variants_data: function (data) {
			let self = this;
			if (typeof data !== 'undefined' && data !== null && typeof data.attributes !== 'undefined' && data.attributes !== null) {

				if (settings.pg_google_track_id !== '' && typeof settings.pg_google_track_id !== 'undefined') {
					self.set_view_product_analytic_event(data);
				}

				let price = typeof data.attributes.price !== 'undefined' ? data.attributes.price : null;
				if (price === null) {
					return;
				}
				if (self.is_tiered_price && typeof data.attributes.tiered_price !== 'undefined') {
					price = data.attributes.tiered_price;
				}

				if (typeof data.inventory !== 'undefined' && typeof data.inventory.attributes.count !== 'undefined') {
					this.show_product_data(
						data.attributes,
						price,
						data.attributes['sale-price'],
						data['subscription-plan'],
						data.inventory,
						this.get_quantity_of_products(),
						true,
					);
				}

				prodigyProductSubscription.load_subscription_price();
			}
		},

		show_variant_sku: function (attributes) {
			let sku;
			if (
				typeof attributes !== 'undefined' &&
				attributes.sku
			) {
				sku = attributes.sku;
			}

			if (sku !== '' && typeof sku !== 'undefined') {
				$('.product_sku_value').text(sku);
			} else {
				$('.prodigy-product__tags-item product_sku').hide();
			}
		},

		set_product_data_for_cart: function (data_variant) {
			let self = this;
			if (typeof data_variant !== 'undefined') {
				if (typeof data_variant.remote_variant_id !== 'undefined') {
					$(self.add_to_cart_button_element).attr('data-remote-id', data_variant.remote_variant_id);
				}

				if (typeof data_variant.local_variant_id !== 'undefined') {
					$(self.add_to_cart_button_element).attr('data-local-id', data_variant.local_variant_id);
				}
			}
		},

		/**
		 * Get obj remote product info
		 *
		 * @version 2.0.0
		 */
		get_master_variant_data: function (number_of_items = 1) {
			let self = this;

			// Use PHP-inlined data for the initial page load to avoid an AJAX round-trip.
			// Subsequent calls (quantity > 1 for tiered pricing) always use AJAX for fresh data.
			if (number_of_items === 1 && !self._masterVariantInitialized) {
				let $inline = $('#master-variant-inline-data-js');
				if ($inline.length && $inline.val()) {
					try {
						let inlineData = JSON.parse($inline.val());
						if (inlineData) {
							self._masterVariantInitialized = true;
							self.remote_product = inlineData;
							self.variant = inlineData.remote_master_variant_info;
							self.show_master_variant_info();
							self.add_item_to_cart();
							return;
						}
					} catch (e) {}
				}
			}

			let post_data = {
				action: 'prodigy-get-master-variant-data',
				post_id: this.get_master_variant_id(),
				items_number: number_of_items,
				nonce: settings.nonce,
			};

			$.ajax(
				{
					type: 'post',
					data: post_data,
					dataType: 'json',
					url: ajax_url,
					success: function (data) {
						self._masterVariantInitialized = true;
						self.remote_product = data.data;
						if (typeof settings.is_captcha !== 'undefined' &&
							settings.is_captcha !== '' &&
							typeof settings.captcha_site_key !== 'undefined' &&
							settings.captcha_site_key !== ''
						) {
							let is_admin = settings.is_admin;
							if (!is_admin) {
								grecaptcha.render(
									'captcha',
									{
										'sitekey': settings.captcha_site_key,
									},
								);
							}
						}

						if (typeof data.data !== 'undefined') {
							self.variant = data.data.remote_master_variant_info;
						}
						self.show_master_variant_info();
						self.add_item_to_cart();
					},
				},
			);
		},

		init_show_more: function () {
			$('body').on(
				'click',
				'.prodigy-product__description-show-more',
				function () {
					let $btn = $(this);
					let $container = $btn.parent();
					let $truncated = $container.find('.prodigy-product__description-truncated');
					let $full = $container.find('.prodigy-product__description-full');
					let show_more = $btn.data('show-more');
					let show_less = $btn.data('show-less');

					if ($truncated.length && $full.length) {
						if ($truncated.is(':visible')) {
							$truncated.hide();
							$full.show();
							if (show_less) {
								$btn.text(show_less);
							}
						} else {
							$truncated.show();
							$full.hide();
							if (show_more) {
								$btn.text(show_more);
							}
						}
					} else {
						let $desc_container = $container.find('.prodigy-product__description-container');
						if ($desc_container.hasClass('prodigy-product__description-container--truncated')) {
							$desc_container.removeClass('prodigy-product__description-container--truncated');
							$container.find('.prodigy-product__description-fade').remove();
							if (show_less) {
								$btn.text(show_less);
							}
						} else {
							$desc_container.addClass('prodigy-product__description-container--truncated');
							if (show_more) {
								$btn.text(show_more);
							}
						}
					}
				},
			);
		},

		init_description_expand: function () {
			$('.prodigy-product__description-expandable--collapsed').each(function () {
				var $wrap = $(this);
				var $truncated = $wrap.find('.prodigy-product__description-container--truncated');
				if ($truncated.length && $truncated[0].scrollHeight > 0) {
					var h = $truncated[0].scrollHeight;
					$wrap.data('collapsed-height', h);
					$wrap.css('max-height', h + 'px');
				}
			});

			$('body').on('click', '.prodigy-product__description-toggle-js', function (e) {
				e.preventDefault();
				var $btn = $(this);
				var $wrap = $btn.prev('.prodigy-product__description-expandable');
				if (!$wrap.length) {
					return;
				}
				var $truncated = $wrap.find('.prodigy-product__description-container--truncated');
				var $full = $wrap.find('.prodigy-product__description-container--full');
				var isCollapsed = $wrap.hasClass('prodigy-product__description-expandable--collapsed');
				var moreText = $btn.data('more');
				var lessText = $btn.data('less');

				if (isCollapsed) {
					$full.attr('aria-hidden', 'false');
					$wrap.removeClass('prodigy-product__description-expandable--collapsed');
					$wrap.css('max-height', $full[0].scrollHeight + 'px');
					$wrap.attr('aria-expanded', 'true');
					$btn.text(lessText);
				} else {
					var collapsedH = $wrap.data('collapsed-height');
					if (!collapsedH && $truncated.length) {
						collapsedH = $truncated[0].scrollHeight;
						$wrap.data('collapsed-height', collapsedH);
					}
					$wrap.css('max-height', (collapsedH || 120) + 'px');
					$wrap.addClass('prodigy-product__description-expandable--collapsed');
					$wrap.attr('aria-expanded', 'false');
					$btn.text(moreText);
					$wrap.one('transitionend', function () {
						$full.attr('aria-hidden', 'true');
					});
				}
			});
		},

		set_customised_variant_selection: function () {
			$(document).find('select[data-attribute]').trigger('focus');
		},

		customise_sort_select: function () {
			$('.prodigy-custom-select').styler(
				{
					onFormStyled: function () {
						$('.jq-selectbox__select-text').each(
							function () {
								const width = $(this)
									.closest('.jq-selectbox')
									.find('select')
									.width();
								$(this).width(width);
							},
						);
					},
				},
			);
		},

		is_validate_options: function () {
			let result = true;
			let self = this;
			$('.bulk-container-js:visible').each(
				function (i, bulk_container) {
					let bulk_result = false;
					$(bulk_container).find(prodigyProductBulk.input_bulk_quantity_element).each(
						function (index, input) {
							if ($(input).val() !== '') {
								bulk_result = true;
							} else {
								bulk_result = bulk_result || false;
							}
						},
					);
					result = result && bulk_result;
				},
			);

			$('.attribute_values_js').each(
				function (e) {
					if (!$(this).hasClass('ignored')) {
						if ($(this).val() === '') {
							result = false;
						} else {
							result = result && true;
						}
					}
				},
			);

			$(self.prodigy_product_swatch_block_element).each(
				function () {
					let self = this;
					let checkbox = $(this).find('.prodigy-product__swatch-js');
					checkbox.each(
						function () {
							if (!checkbox.is(':checked') && !$(self).hasClass('ignored')) {
								result = false;
							} else {
								result = result && true;
							}
						},
					);
				},
			);

			return result;
		},

		validate_options: function () {
			let result = true;
			let self = this;
			$('.bulk-container-js:visible').each(
				function (i, bulk_container) {
					let bulk_result = false;
					$(bulk_container).find(prodigyProductBulk.input_bulk_quantity_element).each(
						function (index, input) {
							if ($(input).val() !== '') {
								bulk_result = true;
							} else {
								bulk_result = bulk_result || false;
							}
						},
					);
					const headers = $(bulk_container).find('.prodigy-tooltip, .prodigy-bulk__table-cell');
					bulk_result ? headers.removeAttr('style') : headers.css('border-color', 'red');
					result = result && bulk_result;
				},
			);

			$('.attribute_values_js').each(function (e) {
					if (!$(this).hasClass('ignored') && $(this).val() === '') {
						$(this).parent().parent().prev().prev().css('color', 'red');
						result = false;
					} else {
						$(this).parent().parent().prev().prev().removeAttr('style');
						result = result && true;
					}
				},
			);

			$('.prodigy-product__swatch-block-js:not(.ignored)').each(
				function () {
					let element = $(this).closest('.prodigy-product__attr-item--no-select-value').find('.prodigy-product__attr-text');
					let checkbox = $(this).find(self.prodigy_product_swatch_element);
					checkbox.each(
						function () {
							if (!checkbox.is(':checked')) {
								element.css('color', 'red');
								result = false;
							} else {
								element.removeAttr('style');
								result = result && true;
							}
						},
					);
				},
			);

			return result;
		},
		hide_empty_div: function () {
			$('.prodigy-product__prop-wrap').each(function () {
					if ($.trim($(this).text()) === '' && $(this).children().length === 0) {
						$(this).hide();
					}
				},
			);
		},
	};

	window.prodigyProduct = prodigy_product;
})(jQuery, window);

jQuery(document).ready(
	function ($) {
		window.prodigyProduct.init();
		window.prodigyProduct.init_description_expand();
		window.prodigyProduct.init_show_more();
		window.prodigyRecaptchaCallback = window.prodigyProduct.captcha_callback.bind(
			window.prodigyProduct,
		);
	},
);
